import React, { useCallback } from 'react'
import { Typography } from '@astrid/components'
import { LibraryItem } from 'components/LibraryItem'
import { StoreRecommendedItem } from 'store/services/Library/Library.types'

type RecommendedItemProps = {
  item: StoreRecommendedItem
  onClick: (recommendedItem: StoreRecommendedItem) => void
}

export const RecommendedItem = ({ item, onClick }: RecommendedItemProps) => {
  const _onClick = useCallback(() => onClick(item), [onClick, item])

  if (!item) return null

  return (
    <section aria-labelledby="recommended-heading" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Typography id="recommended-heading" style={{ margin: 0, fontWeight: 900, fontSize: 24 }} variant="h2">
        For you
      </Typography>
      <LibraryItem isRecommended item={item} onClick={_onClick} />
    </section>
  )
}
